// Company videos moved from Vimeo to Cloudflare Stream (Oct 2026: the Vimeo account is locked,
// WA-2391). The backend still stores the Vimeo id; this host maps that same id to the Stream copy,
// so no backend change is needed. A 404 means the video was deleted on Vimeo before the move.
// currently accessed thru a cloudflare worker for vimeo ID mapping and switching to R2, 
// TODO: just use direct links to cloudflare stream or R2 instead
export const COMPANY_VIDEO_HOST =
  process.env.NEXT_PUBLIC_COMPANY_VIDEO_HOST ||
  "https://hiredly-video-backup.hiredly-wobb-cloudflare-account.workers.dev";

// HLS stream for a company video, played by react-player's file player.
export const companyVideoUrl = (vimeoId) =>
  vimeoId ? `${COMPANY_VIDEO_HOST}/v/${vimeoId}.m3u8` : "";

// Poster image for the click-to-play preview (react-player `light`).
export const companyVideoPoster = (vimeoId) =>
  vimeoId ? `${COMPANY_VIDEO_HOST}/thumb/${vimeoId}.jpg` : true;

export const isCompanyVideoUrl = (url) =>
  typeof url === "string" && url.startsWith(COMPANY_VIDEO_HOST);

export const companyVideoPosterFromUrl = (url) =>
  isCompanyVideoUrl(url)
    ? url.replace("/v/", "/thumb/").replace(/\.m3u8$/, ".jpg")
    : true;

// Videos of companies without a live job are kept in R2 as plain MP4 (Oct 2026: Stream holds live-job
// companies only). When the Stream link 404s, the player switches once to the R2 copy.
export const companyVideoArchiveUrl = (url) =>
  isCompanyVideoUrl(url) ? url.replace(/\.m3u8$/, ".mp4") : url;
